// Playlist files (.m3u, .pls, .asx, .xspf) list stream addresses instead of carrying audio.
// Browsers cannot play them, so the player asks the server for the stream they point to.
// HLS (.m3u8) is not included: hls.js and native HLS play it directly.
export function isPlaylistURL(value){
  try{return /\.(m3u|pls|asx|xspf)$/i.test(new URL(value).pathname);}catch{return false;}
}
// A .m3u served as HLS (segments or variants) plays like any .m3u8.
export const isHlsPlaylist=text=>/#EXT-X-(TARGETDURATION|STREAM-INF|MEDIA-SEQUENCE)/.test(text);
const xmlText=value=>value.replace(/&amp;/g,'&').replace(/&lt;/g,'<').replace(/&gt;/g,'>').replace(/&quot;/g,'"').replace(/&#0*39;|&apos;/g,"'").trim();
// http(s) entries of a playlist in order, resolved against the playlist's own address.
export function playlistEntries(text,base){
  const body=String(text||'').replace(/^﻿/,'');
  let raw;
  if(/^\s*\[playlist\]/i.test(body)||/^\s*File\d+\s*=/im.test(body))raw=[...body.matchAll(/^\s*File\d+\s*=\s*(.+?)\s*$/gim)].map(m=>m[1]);
  else if(/^\s*</.test(body))raw=[...body.matchAll(/<ref\b[^>]*?\bhref\s*=\s*["']([^"']+)["']|<location>([^<]+)<\/location>/gi)].map(m=>xmlText(m[1]||m[2]));
  else raw=body.split(/\r?\n/).map(line=>line.trim()).filter(line=>line&&!line.startsWith('#'));
  const entries=[];
  for(const entry of raw){
    try{const url=new URL(entry,base);if(['http:','https:'].includes(url.protocol)&&!entries.includes(url.href))entries.push(url.href);}catch{}
  }
  return entries;
}
